/**
 * Map name for mutations
 * @types {string}
 */

export const SET_REQUESTS = "SET_REQUESTS";
